import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import differenceInSeconds from "date-fns/differenceInSeconds";

// AWS
import { API, Storage, Auth } from "aws-amplify";

function useGetLoan({
  ...query
  // Limit,
  // countData,
  // FilterExpression,
  // attributeNames,
  // attributeValues,
  // paid_date,
  // loan_status,
  // overdueDateMin,
  // overdueDateMax,
}) {
  const [datas, setDatas] = useState([]);
  const [error, setError] = useState();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData(query);
  }, []);

  const getData = async (
    query = {},
    options = { sortBy: "", isLoading: true }
  ) => {
    try {
      setLoading(options.isLoading);
      const datas = await API.get("MoneyHubAdmin", "/loan/sandbox", {
        queryStringParameters: {
          ...query,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      const parseData = JSON.parse(datas.body);
      let newDatas = await Promise.all(
        parseData?.Items?.map(async (data, index) => {
          return {
            ...data,
            sort: +index + 1,
          };
        })
      );

      if (options.sortBy) {
        newDatas = newDatas.sort((a, b) => b.sort - a.sort);
      }
      setCount(datas.count);
      setDatas(newDatas);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
      console.log(error);
    }
  };

  return {
    datas,
    setDatas,
    count,
    error,
    setError,
    loading,
    setLoading,
    getData,
  };
}

export default useGetLoan;
